module.exports = __webpack_public_path__ + "img/img57.1a233ed6.png";